import type { DomainVisitors } from '@/modules/Domains';
import { BulkRedirectByPathItem, ParsedRedirectRow, RedirectMatchMode } from '@/modules/Sites/Redirects';

const normalizePath = (value: string): string => value.trim().toLowerCase();

export const parseBulkRedirects = (text: string): ParsedRedirectRow[] => {
  const rows: ParsedRedirectRow[] = [];

  text.split(/\r?\n/).forEach((raw, index) => {
    const line = raw.trim();

    if (!line) return;

    const [pathFrom = '', pathTo = ''] = line.split(/\s+-\s+/).map((element) => normalizePath(element));

    rows.push({ key: `${ index }-${ raw }`, line: index + 1, raw, pathFrom, pathTo });
  });

  return rows;
};

export const buildBulkRedirectItems = (
  rows: ParsedRedirectRow[],
  statusCode: number,
  matchMode: RedirectMatchMode,
  forVisitor: DomainVisitors,
  isActive: boolean
): BulkRedirectByPathItem[] =>
  rows
    .filter(({ pathFrom, pathTo }) => Boolean(pathFrom) && Boolean(pathTo))
    .map(({ pathFrom, pathTo }) => ({ pathFrom, pathTo, statusCode, matchMode, forVisitor, isActive }));

